import context, { SystemConstants } from '@truckdown/components-systems';
import { defineComponent, ref, Ref, onMounted, onUnmounted, computed } from 'vue';

interface IProps {
    section: string;
}

interface IStep {
    id: string;
    label: string;
    complete: boolean;
}

interface IData {
    steps: Ref<IStep[]>;
}

const getSteps = function () {
    const setting = context.settings['fleet_onboarding'];
    return [
        { id: 'team', label: 'Add Team Members', complete: setting == 'team' || setting == 'favorites' || setting == 'vendors' || setting == 'setup' || setting == 'complete' },
        { id: 'favorites', label: 'Add Favorites', complete: setting == 'favorites' || setting == 'vendors' || setting == 'setup' || setting == 'complete' },
        { id: 'vendors', label: 'Import Vendors', complete: setting == 'vendors' || setting == 'setup' || setting == 'complete' },
        { id: 'setup', label: 'Activate Fleet Account', complete: setting == 'setup' || setting == 'complete' }
    ];
}

const getData = function (props: IProps) {
    return {
        steps: ref<IStep[]>(getSteps())
    } as IData;
}

const getComputed = function (props: IProps, data: IData) {
    return {
        currentStep: computed(() => {
            const index = data.steps.value.findIndex(step => step.id === props.section);
            return index !== -1 ? index + 1 : 1;
        }),
        currentStepLabel: computed(() => {
            const index = data.steps.value.findIndex(step => step.id === props.section);
            return index !== -1 ? data.steps.value[index].label : "Add Team Members";
        }),
        showPrevious: computed(() => {
            return props.section != 'team';
        }),
        showNext: computed(() => {
            const current = data.steps.value.find(step => step.id === props.section) ?? data.steps.value[0];
            return current.complete;
        })
    };
}

const getMethods = function (props: IProps, ctx: any, data: IData) {
    return {
        navigateStep: function (id: string) {
            const index = data.steps.value.findIndex(step => step.id === id);
            if (
                (index >= 0 && data.steps.value[index].complete)
                || (index > 0 && data.steps.value[index - 1].complete)) {
                ctx.emit('change-section', id);
            }
        },
        stepBack: function () {
            const index = data.steps.value.findIndex(step => step.id === props.section);
            if (index > 0) {
                const newStep = data.steps.value[index - 1];
                ctx.emit('change-section', newStep.id);
            }
        },
        stepForward: function () {
            const index = data.steps.value.findIndex(step => step.id === props.section);
            if (index < 3) {
                const newStep = data.steps.value[index + 1];
                ctx.emit('change-section', newStep.id);
            }
        }
    };
}

export default defineComponent({
    props: {
        section: {
            type: String,
            required: true
        }
    },
    name: "fleet-setup-side-bar",
    emits: ['change-section'],
    components: {
    },
    setup: function (props: IProps, ctx: any) {
        const data = getData(props);
        const computed = getComputed(props, data);
        const methods = getMethods(props, ctx, data);

        const refreshContext = function () {
            data.steps.value = getSteps();
        }

        onMounted(() => {
            context.events.on(SystemConstants.Events.RefreshOnboardingProgress, refreshContext);
        });

        onUnmounted(() => {
            context.events.off(SystemConstants.Events.RefreshOnboardingProgress, refreshContext);
        });

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});